import { GetProductsParams, inventoryProductService } from "../../../../../Api/Services/InventoryService/inventoryProduct";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { InventoryProductListResponse } from "../../../products/types";


// --- Thunk ---
export const fetchEmployeeInventoryProducts = createServiceAsyncThunk<
  InventoryProductListResponse,
  GetProductsParams
>(
  ACTION_NAMES.FETCH_EMPLOYEE_INVENTORY_PRODUCT_LIST,
  (params) => inventoryProductService.getProducts(params),
  ERROR_MESSAGES.FETCH_EMPLOYEE_INVENTORY_PRODUCT_FAILURE
);

// --- Slice ---
const employeeInventoryProductSlice = createGenericSlice<
  InventoryProductListResponse,
  GetProductsParams
>(
  SLICE_NAMES.EMPLOYEE_INVENTORY_PRODUCT_LIST_SLICE,
  fetchEmployeeInventoryProducts
);

export const {
  clearError: clearEmployeeInventoryProductListError,
  clearSuccessMessage: clearEmployeeInventoryProductListSuccessMessage,
} = employeeInventoryProductSlice.actions;

export default employeeInventoryProductSlice.reducer;
